<template>
<div class="container-bible h-100 overflow-y-s bible-text" id="app-bible-text">
    <div class="text-right">
        <button type="button" class="btn-copy-chapter btn btn-outline-secondary" @click="copyChapter">章コピー</button>
    </div>
    <div v-html="$store.state.data.current.chapter.html" ref="htmlContainer" class="html-container" style="padding-bottom: 3em;"></div>
</div>
</template>

<script>
import jQuery from 'jquery'

export default {
  computed: {
  },
  watch: {
    '$store.state.data.current.chapter.value': {
      handler: 'onUpdateChapter',
      deep: true,
    },
    '$store.state.data.current.verse': {
      handler: 'onUpdateVerse',
      deep: true,
    },
    '$store.state.data.scroll.updated_at': {
      handler: 'onUpdateScrollUpdatedAt',
      deep: true,
    },
  },
  methods: {
    onUpdateChapter () {
      this.addEventListener()

      this.$nextTick(() => {
        this.onUpdateVerse()
      })
    },

    onUpdateVerse () {
      const $htmlContainer = jQuery(this.$refs.htmlContainer)
      const code = this.$store.state.data.current.verse.code
      $htmlContainer.find('a.v[active]').removeAttr('active')
      $htmlContainer.find('a.v[index=' + code + ']').attr('active', true)
    },

    onUpdateScrollUpdatedAt () {
      this.scrollTo({ index: this.$store.state.data.scroll.text })
    },

    addEventListener () {
      this.$nextTick(() => {
        const $htmlContainer = jQuery(this.$refs.htmlContainer)
        const $links = $htmlContainer.find('a')
        $links.on('click', (e) => {
          const $link = jQuery(e.currentTarget)
          const verse = this.$store.getters.verse({ code: $link.attr('index') })

          switch ($link.attr('class')) {
            case 'v':
//              if ($link.attr('active')) {
//                this.$store.dispatch('uiToggleModalBibleAction', true)
//              } else {
                if (verse) {
                  this.$store.dispatch('dataSetIndex', {
                    indexes: {
                      verse: verse.order,
                    },
                  })
                }
//              }
              break
            case 'other':
              this.$store.dispatch('dataSetIndex', {
                indexes: {
                  other: $link.prop('outerHTML'),
                },
              })
              break
          }

          this.$store.dispatch('uiToggleModalBibleAction', true)
        })
      })
    },

    scrollTo(params) {
      setTimeout(() => {
        const $htmlContainer = jQuery(this.$refs.htmlContainer);

        let code = null
        if (params.code) {
          code = params.code
        } else if (typeof params.index === 'number') {
          code = this.$store.state.data.current.verse.code
        }

        let target = $htmlContainer.find('a.v[index=' + code + ']').get(0)

        const verse = this.$store.getters.verse({ code: code })

        if (!verse) {
          return
        }

        let offset = -20;
        if (verse.order === 0) {
          offset = -1000;
        }

        this.$scrollTo(
          target,
          1,
          {
            container: '#app-bible-text',
            offset: offset,
          }
        )
      }, 100)
    },

    copyChapter() {
        this.$store.dispatch('uiToggleModalBibleCopy', true)
    },
  },

  mounted: function() {
  },
};
</script>

